// import React, { useState } from "react";

// export function ProjectVandeMataram() {
//   const [loading, setLoading] = useState(true);

//   return (
//     <div
//       style={{
//         // margin: "1rem",
//         width: "100%",
//         height: "100vh",
//         overflow: "hidden"
//       }}
//     >
//       {loading && (
//         <div
//           style={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             width: "100%",
//             height: "100vh",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center"
//           }}
//         >
//           Loading please wait...
//         </div>
//       )}

//       <iframe
//         src="/nl-sena/p-v-m?embed=true"
//         title="Project Vande Mataram"
//         onLoad={() => setLoading(false)}
//         style={{
//           width: "100%",
//           height: "90vh",
//           border: "none",
//           display: "block"
//         }}
//       />
//     </div>
//   );
// }


import React from "react";
import { NLSenaDetailPage } from "../nl-sena-detail";

export const ProjectVandeMataram = props => {
  return (
    <NLSenaDetailPage
      props={props}
      id={2579}
    />
  );
};